import { createSlice } from '@reduxjs/toolkit';
import { localStorageHelper } from 'src/services';

const darkModeSlice = createSlice({
    name: 'darkMode',
    initialState: { isDarkMode: localStorageHelper.GetDarkMode() },
    reducers: {
        changeDarkModeReducer: (state) => {
            const newValue = !localStorageHelper.GetDarkMode();
            localStorageHelper.SetDarkMode(newValue);
            state = { isDarkMode: newValue };
            return state;
        }
    }
});

export const darkModeReducer = darkModeSlice.reducer;

export const { changeDarkModeReducer } = darkModeSlice.actions;
